import axios from 'axios'


// 添加请求拦截器
// 创建 Axios 实例
const instance = axios.create({
  timeout: 5000, // 设置超时时间
});

instance.interceptors.request.use(
  function (config) {
    // console.log('config~~~~~~~~~`',config);
    // console.log('config~~~~~headers~~~~`',config.headers);
    if(!config.headers){
      config.headers = {}
    }
    config = MiguplayUtils.crypto.formatParams({
      requestData: config,
    });
    
    
    return config;
  },
  function (error) {
   
    return Promise.reject(error);
  }
);
// 添加响应拦截器
instance.interceptors.response.use(
  function (response) {
    response = MiguplayUtils.crypto.formatParams({
      responseData: response,
    });
    // console.log("\x1b[32m%s\x1b[0m",'请求解密后',response);
 
    return response;
  },
  function (error) {
    
    return Promise.reject(error);
  }
);

export default instance




// WEBPACK FOOTER //
// ./src/api/request.js